import SPXStrangleBacktestTable from './SPXStrangleBacktestTable';

// Data from backend/cmd/spx20ptbacktest -distance=5, run against real
// historical Alpaca data 2026-06-01..2026-07-16. Same rules as the 20pt
// version (see SPX20PointStrangleTable.js) - only the strike distance
// differs, which puts these contracts much closer to the money and
// therefore far more expensive, so the $500 budget is consumed in far fewer
// trades.
const ROWS = [
  ['01-06-2026', 7615.72, 'CALL', 7620, 'filled', 0.03, 0.03, 0.05, 0.02, 0.00, 0.00, 497.00],
  ['01-06-2026', 7615.72, 'PUT', 7610, 'skipped_budget', 6.50, 497.00],
  ['02-06-2026', 7619.58, 'CALL', 7625, 'filled', 0.03, 0.03, 0.05, 0.01, 0.00, 0.00, 494.00],
  ['02-06-2026', 7619.58, 'PUT', 7615, 'filled', 4.80, 4.20, 5.70, 2.50, -60.00, -12.50, 14.00],
  ['03-06-2026', 7577.22, 'CALL', 7580, 'skipped_budget', 0.14, 14.00],
  ['03-06-2026', 7577.22, 'PUT', 7570, 'skipped_budget', 2.20, 14.00],
  ['04-06-2026', 7573.71, 'CALL', 7580, 'skipped_budget', 14.05, 14.00],
  ['04-06-2026', 7573.71, 'PUT', 7570, 'filled', 0.07, 0.03, 0.10, 0.01, -4.00, -57.14, 7.00],
  ['05-06-2026', 7401.30, 'CALL', 7405, 'skipped_budget', 5.00, 7.00],
  ['05-06-2026', 7401.30, 'PUT', 7395, 'skipped_budget', 3.50, 7.00],
  ['08-06-2026', 7400.33, 'CALL', 7405, 'skipped_budget', 4.70, 7.00],
  ['08-06-2026', 7400.33, 'PUT', 7395, 'skipped_budget', 0.70, 7.00],
  ['09-06-2026', 7332.63, 'CALL', 7340, 'skipped_budget', 9.37, 7.00],
  ['09-06-2026', 7332.63, 'PUT', 7330, 'skipped_budget', 1.85, 7.00],
  ['10-06-2026', 7284.59, 'CALL', 7290, 'skipped_budget', 1.95, 7.00],
  ['10-06-2026', 7284.59, 'PUT', 7280, 'skipped_budget', 5.70, 7.00],
  ['11-06-2026', 7379.87, 'CALL', 7385, 'skipped_budget', 10.41, 7.00],
  ['11-06-2026', 7379.87, 'PUT', 7375, 'skipped_budget', 0.60, 7.00],
  ['12-06-2026', 7412.35, 'CALL', 7415, 'skipped_budget', 9.30, 7.00],
  ['12-06-2026', 7412.35, 'PUT', 7405, 'skipped_budget', 0.37, 7.00],
  ['15-06-2026', 7545.14, 'CALL', 7550, 'skipped_budget', 8.20, 7.00],
  ['15-06-2026', 7545.14, 'PUT', 7540, 'skipped_budget', 0.07, 7.00],
  ['16-06-2026', 7511.17, 'CALL', 7515, 'skipped_budget', 6.10, 7.00],
  ['16-06-2026', 7511.17, 'PUT', 7505, 'skipped_budget', 0.40, 7.00],
  ['17-06-2026', 7419.64, 'CALL', 7425, 'skipped_budget', 3.50, 7.00],
  ['17-06-2026', 7419.64, 'PUT', 7415, 'skipped_budget', 4.90, 7.00],
  ['18-06-2026', 7479.65, 'CALL', 7485, 'skipped_budget', 16.00, 7.00],
  ['18-06-2026', 7479.65, 'PUT', 7475, 'skipped_data', null, 7.00],
  ['22-06-2026', 7461.62, 'CALL', 7465, 'skipped_budget', 3.80, 7.00],
  ['22-06-2026', 7461.62, 'PUT', 7455, 'skipped_budget', 0.32, 7.00],
  ['23-06-2026', 7376.15, 'CALL', 7380, 'skipped_budget', 2.40, 7.00],
  ['23-06-2026', 7376.15, 'PUT', 7370, 'skipped_budget', 2.09, 7.00],
  ['24-06-2026', 7340.30, 'CALL', 7345, 'skipped_budget', 8.20, 7.00],
  ['24-06-2026', 7340.30, 'PUT', 7335, 'skipped_budget', 0.60, 7.00],
  ['25-06-2026', 7333.46, 'CALL', 7340, 'skipped_budget', 7.60, 7.00],
  ['25-06-2026', 7333.46, 'PUT', 7330, 'skipped_budget', 0.50, 7.00],
  ['26-06-2026', 7353.77, 'CALL', 7360, 'skipped_budget', 3.60, 7.00],
  ['26-06-2026', 7353.77, 'PUT', 7350, 'skipped_budget', 1.00, 7.00],
  ['29-06-2026', 7435.33, 'CALL', 7440, 'skipped_budget', 1.77, 7.00],
  ['29-06-2026', 7435.33, 'PUT', 7430, 'skipped_budget', 0.70, 7.00],
  ['30-06-2026', 7497.58, 'CALL', 7505, 'skipped_budget', 1.35, 7.00],
  ['30-06-2026', 7497.58, 'PUT', 7495, 'skipped_budget', 2.90, 7.00],
  ['01-07-2026', 7494.60, 'CALL', 7500, 'skipped_budget', 0.90, 7.00],
  ['01-07-2026', 7494.60, 'PUT', 7490, 'skipped_budget', 1.65, 7.00],
  ['02-07-2026', 7453.82, 'CALL', 7460, 'skipped_budget', 3.80, 7.00],
  ['02-07-2026', 7453.82, 'PUT', 7450, 'skipped_budget', 0.75, 7.00],
  ['06-07-2026', 7539.75, 'CALL', 7545, 'skipped_budget', 3.90, 7.00],
  ['06-07-2026', 7539.75, 'PUT', 7535, 'skipped_budget', 0.30, 7.00],
  ['07-07-2026', 7483.97, 'CALL', 7490, 'skipped_budget', 8.00, 7.00],
  ['07-07-2026', 7483.97, 'PUT', 7480, 'skipped_budget', 0.20, 7.00],
  ['08-07-2026', 7492.84, 'CALL', 7500, 'filled', 0.03, 0.03, 0.10, 0.01, 0.00, 0.00, 4.00],
  ['08-07-2026', 7492.84, 'PUT', 7490, 'skipped_budget', 16.60, 4.00],
  ['09-07-2026', 7530.90, 'CALL', 7535, 'skipped_budget', 5.20, 4.00],
  ['09-07-2026', 7530.90, 'PUT', 7525, 'skipped_budget', 0.20, 4.00],
  ['10-07-2026', 7578.35, 'CALL', 7585, 'skipped_budget', 0.42, 4.00],
  ['10-07-2026', 7578.35, 'PUT', 7575, 'skipped_budget', 1.40, 4.00],
  ['13-07-2026', 7511.62, 'CALL', 7515, 'skipped_budget', 3.20, 4.00],
  ['13-07-2026', 7511.62, 'PUT', 7505, 'skipped_budget', 0.75, 4.00],
  ['14-07-2026', 7552.66, 'CALL', 7560, 'skipped_budget', 0.17, 4.00],
  ['14-07-2026', 7552.66, 'PUT', 7550, 'skipped_budget', 1.90, 4.00],
  ['15-07-2026', 7565.60, 'CALL', 7570, 'skipped_budget', 0.50, 4.00],
  ['15-07-2026', 7565.60, 'PUT', 7560, 'skipped_budget', 1.70, 4.00],
  ['16-07-2026', 7513.31, 'CALL', 7520, 'skipped_budget', 0.60, 4.00],
  ['16-07-2026', 7513.31, 'PUT', 7510, 'skipped_budget', 5.00, 4.00],
];

export default function SPX5PointStrangleTable() {
  return (
    <SPXStrangleBacktestTable
      title="SPX 5pt Strangle @ 3:50 PM — Hold to Close"
      subtitle="Same rules as the 20pt test (2026-06-01 → 2026-07-16, 3:50 PM ET entry, hold to close, never sell, $500 running budget, no commission), just with the call/put strikes only ~5pts from spot instead of ~20. Being much closer to the money makes these contracts far more expensive, so the budget disappears in far fewer trades — only 5 of 62 legs filled here vs 15 for the 20pt version."
      rows={ROWS}
    />
  );
}
